<template>
    <div class="pt-[20px] pr-[0px] bg-[#ededed]">
        <div class="max-w-[1400px] w-full container mx-auto">
            <div class="lg:pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]">
                <h2 class="pt-5 pb-4 mt-4 text-sm sm:text-2xl">
                    <strong>Monatsreport</strong> - Management Tool
                </h2>
                <div class="inline w-1/3 text-lg">
                    <h1 class="pb-3">
                        <strong>{{ dateValues.timetitle }}</strong>
                    </h1>
                    <h2>
                        Eigenes Datum angeben:
                        <input
                            type="month"
                            class="ml-[2%] mb-3"
                            v-model="dateValues.timestamp"
                            @keyup.enter="dateValues.timetitle = dateValues.timestamp"
                            title="Eingabe + Enter"
                        />
                    </h2>
                </div>
            </div>
        </div>
    </div>
    <div class="max-w-[1400px] w-full container mx-auto">
        <div class="pr-[20px] pb-[40px] pl-[10px] max-w-[1400px] pt-4">
            <div class="mb-5">
                <div class="overflow-x-auto mb-[5%]">
                    <table
                        class="border-collapse w-full border-[1px] border-gray-400 mt-[50px] mr-auto rounded-sm text-center text-[8px] lg:text-lg"
                    >
                        <thead>
                            <tr
                                class="border-b-[1px] border-gray-500 bg-[#db0720] text-white font-medium"
                            >
                                <th class="font-medium">Tag</th>
                                <th class="font-medium"></th>
                                <th class="font-medium">Fe</th>
                                <th class="font-medium">Kr</th>
                                <th class="font-medium" colspan="4" v-for="n in 24">
                                    {{ n - 1 }}
                                </th>
                                <th class="font-medium">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="value in worktimeValues"
                                :key="value.dayNumber"
                                :class="value.dayName != '' ? 'bg-[#ededed]' : ''"
                                class="border-b-[1px] border-gray-200 hover:bg-[#ededed]"
                            >
                                <td class="border-r-[1px] border-gray-300">
                                    <strong>{{ value.dayNumber }}</strong>
                                </td>
                                <td class="border-r-[1px] border-gray-300">
                                    {{ value.dayName }}
                                </td>
                                <td
                                    v-if="value.Fe === true"
                                    class="bg-[#db0720] text-white border-r-[1px] border-gray-300"
                                >
                                    X
                                </td>
                                <td v-else class="border-r-[1px] border-gray-300"></td>
                                <td
                                    v-if="value.Kr === true"
                                    class="bg-[#db0720] text-white border-r-[1px] border-gray-300"
                                >
                                    X
                                </td>
                                <td v-else class="border-r-[1px] border-gray-300"></td>
                                <td
                                    v-for="instance in value.worktime"
                                    :class="instance ? 'bg-[#0faedd]' : ''"
                                ></td>
                                <td class="border-l-[1px] border-gray-300">
                                    <strong>{{ value.total }}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="overflow-x-auto mt-5 mb-[3%] shadow">
                    <table class="w-full border-[1px] text-left text-[8px] lg:text-lg">
                        <thead class="text-white">
                            <tr class="border-b-[1px] border-black bg-[#db0720] py-2">
                                <th class="w-[8.5%] font-medium p-3" v-if="screenWidth >= 1000">
                                    Person
                                </th>
                                <th class="w-[8.5%] font-medium p-3">Präsenzzeit</th>
                                <th class="w-[8.5%] font-medium p-3">Arbeitszeit laufende woche</th>
                                <th class="w-[8.5%] font-medium p-3">Sollarbeitszeit Vollpensum</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="border-b-2">
                                <td class="w-[8.5%] font-medium p-3" v-if="screenWidth >= 1000">
                                    {{ personalValues.name }}
                                </td>
                                <td class="w-[8.5%] font-medium p-3">
                                    {{ personalValues.worktimeDay }}
                                </td>
                                <td class="w-[8.5%] font-medium p-3">
                                    {{ personalValues.worktimeSumWeek }}
                                </td>
                                <td class="w-[8.5%] font-medium p-3">
                                    {{ personalValues.worktimeDue }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="py-5">
                    <FullButton title="Zurück" link="/timesheet" width="100" colour="white" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue'
    import sourceData from '@/components/MockJSONFiles (temp)/MockJSONReportFile.json' // MOCK JSON file
    import FullButton from '@/components/Buttons/FullButton.vue'

    export default defineComponent({
        data() {
            return {
                dateValues: {
                    timestamp: '',
                    timetitle: '',
                    year: '',
                    month: '',
                },
                worktimeValues: sourceData.data,
                personalValues: sourceData.person,

                screenWidth: window.innerWidth,
            }
        },

        components: {
            FullButton,
        },

        mounted() {
            this.updateValues()
            // TODO: fetch data from API and set values to data
            // TODO: Onchange and enter press of input field get data from said month and change DOM
        },

        methods: {
            getDimensions() {
                this.screenWidth = document.documentElement.clientWidth
            },

            // get current year and month and add to title

            updateValues() {
                const today = new Date()
                this.dateValues.year = today.getFullYear()

                this.dateValues.month =
                    (today.getMonth() + 1).toString().length < 2
                        ? '0' + (today.getMonth() + 1)
                        : today.getMonth() + 1

                this.dateValues.timestamp = this.dateValues.year + '-' + this.dateValues.month
                this.dateValues.timetitle = this.dateValues.timestamp
            },
        },
    })
</script>
